// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.3@core-js/library/modules/_is-array.js
// module id = 354
// module chunks = 0 1